// import logo from './logo.svg';
import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import Term from './view_components/Policy/Term/Term';
// import Privacy from './view_components/Policy/Privacy/Privacy';
// import KushmandaHome from './view_components/New Product/LandingPage/LandingPage';
import HeroSection from './view_components/View/HeroSection';

function App() {
  return (

    <div className='app'>
      <BrowserRouter>
        {/* <Navbar /> */}
        <Routes>
          {/* <Route exact path="/newhome" element={<Home />} />
          <Route exact path="/home" element={<LandingPageFile />} /> */}
          {/* <Route exact path="/" element={<KushmandaHome />} /> */}
          <Route exact path="/" element={<HeroSection />} />
          <Route exact path="*" element={<Navigate to="/" />} />
          {/* <Route exact path="/Products/MyLuckyDays/Terms_and_Conditions" element={<Term />} /> */}
          {/* <Route exact path="/Products/MyLuckyDays/PrivacyPolicy" element={<Privacy />} /> */}


        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
